import clsx from 'clsx'
import { createElement } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './form-builder-card-config.module.scss'
import { FormActiveItem } from '../../types/form-builder.types'
import { builderComponentConfigFactory } from '../../utils/builder-component-config-factory'

type FormBuilderCardConfigProps = {
  item: FormActiveItem
}

export const FormBuilderCardConfig = ({ item }: FormBuilderCardConfigProps) => {
  const { t } = useTranslation()
  const component = createElement(builderComponentConfigFactory(item.type), item.config)

  return (
    <div className={clsx(styles.configWrapper)}>
      <p>{t(item.title)}</p>
      <div>{component}</div>
    </div>
  )
}
